module.exports = __webpack_public_path__ + "img/ic-7.6835244.svg";